export const getUserAvatarText = (username) => {
    return username.split(/\s+/).map((w, i) => i < 2 ? w.substring(0, 1).toUpperCase() : '').join('');
};